import React from 'react';
import './style.css';

const Logo = () => {
  return (
    <a href="/" className="logo-link">
      <svg width="200" height="50" xmlns="http://www.w3.org/2000/svg">
        <text
          x="8"
          y="75%"
          className="logo-text"
        >
          &lt;OrhanYilmaz/&gt;
        </text>
      </svg>
    </a>
  );
};

export default Logo;
